import React from "react";
import PropTypes from "prop-types";
import { Button, Segment, Form, Header } from "semantic-ui-react";
import { Field, reduxForm } from "redux-form";
import CustomSearch from "../../shared/CustomSearch";
import isEmpty from "lodash/isEmpty";

const propTypes = {
  placeholder: PropTypes.string,
  handleInscribirEnColegio: PropTypes.func,
  handleVerTodos: PropTypes.func,
  showAddButton: PropTypes.bool
};

const defaultProps = {
  placeholder: "Introduzca el nombre del colegio",
  showAddButton: false
};

class Buscador extends React.Component {
  state = {
    value: ""
  };

  handleInscripcionClick = (e, { name }) => {
    this.props.handleInscribirEnColegio(name, { busqueda: this.state.value });
    this.setState({ value: "reset" });
  };

  handleAdjuntarDocClick = () => this.props.handleAdjuntarDoc();

  handleSelection = keySelected => this.setState({ value: keySelected });

  renderTextField = ({ input, meta: { touched, error }, ...others }) => (
    <CustomSearch
      fluid
      iconPosition="left"
      {...input}
      {...others}
      value={this.state.value}
    />
  );

  render() {
    return (
      <Segment textAlign="center">
        <Header>Busca el colegio donde quieres realizar la inscripción</Header>

        <Form>
          <Form.Field>
            <Field
              id="buscadorColegios"
              name="buscadorColegios"
              type="text"
              placeholder={this.props.placeholder}
              datosBusqueda={this.props.searchData}
              onSelect={this.handleSelection}
              icon="search"
              component={this.renderTextField}
            />
          </Form.Field>
          <Form.Field>
            <Button.Group fluid>
              <Button
                basic={isEmpty(this.state.value)}
                disabled={isEmpty(this.state.value)}
                color="pink"
                name="inscribirEnColegio"
                onClick={this.handleInscripcionClick}
                content="Realizar inscripción en este colegio"
              />
              <Button
                basic={!isEmpty(this.state.value)}
                color="pink"
                name="verTodos"
                onClick={this.props.handleMostrarTodos}
                content="Mostrar todos los colegios disponibles"
              />
              <Button
                basic={isEmpty(this.state.value)}
                color="pink"
                name="adjuntarDocumentoPago"
                onClick={this.handleAdjuntarDocClick}
                content="Adjuntar Documento de Pago"
              />
            </Button.Group>
          </Form.Field>
        </Form>
      </Segment>
    );
  }
}

Buscador.propTypes = propTypes;
Buscador.defaultProps = defaultProps;

export default reduxForm({ form: "" })(Buscador);



// WEBPACK FOOTER //
// ./src/pages/inscripciones/buscadorColegios/Buscador.jsx